import _regeneratorRuntime from "/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRef, useState, useCallback, useEffect, createContext, useContext, createElement } from 'react';
var isCheckBoxInput = function isCheckBoxInput(type) {
  return type === 'checkbox';
};
function attachEventListeners(_ref) {
  var field = _ref.field,
    validateAndStateUpdate = _ref.validateAndStateUpdate,
    isRadio = _ref.isRadio,
    isOnBlur = _ref.isOnBlur;
  var ref = field.ref;
  if (!ref.addEventListener) return;
  ref.addEventListener(isCheckBoxInput(ref.type) || isRadio ? 'change' : 'input', validateAndStateUpdate);
  if (isOnBlur) ref.addEventListener('blur', validateAndStateUpdate);
}
var isUndefined = function isUndefined(val) {
  return val === undefined;
};
var isNullOrUndefined = function isNullOrUndefined(value) {
  return value === null || isUndefined(value);
};
var isArray = function isArray(value) {
  return Array.isArray(value);
};
var isObject = function isObject(value) {
  return !isNullOrUndefined(value) && !isArray(value) && typeof value === 'object';
};
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var reIsPlainProp = /^\w*$/;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value) {
  return reIsUint.test(value) && value > -1;
}
function isKey(value) {
  if (isArray(value)) return false;
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value);
}
var stringToPath = function stringToPath(string) {
  var result = [];
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
};
function set(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath(path);
  var length = tempPath.length;
  var lastIndex = length - 1;
  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;
    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject(objValue) || isArray(objValue) ? objValue : isIndex(tempPath[index + 1]) ? [] : {};
    }
    object[key] = newValue;
    object = object[key];
  }
  return object;
}
var combineFieldValues = function combineFieldValues(data) {
  return Object.entries(data).reduce(function (previous, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    if (!!key.match(/\[.+\]/gi) || key.indexOf('.') > 0) {
      set(previous, key, value);
      return previous;
    }
    return Object.assign(Object.assign({}, previous), _defineProperty({}, key, value));
  }, {});
};
var removeAllEventListeners = function removeAllEventListeners(ref, validateWithStateUpdate) {
  if (!ref.removeEventListener) return;
  ref.removeEventListener('input', validateWithStateUpdate);
  ref.removeEventListener('change', validateWithStateUpdate);
  ref.removeEventListener('blur', validateWithStateUpdate);
};
var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit'
};
var RADIO_INPUT = 'radio';
var isRadioInput = function isRadioInput(type) {
  return type === RADIO_INPUT;
};
function isDetached(element) {
  if (!element) return true;
  if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) return false;
  return isDetached(element.parentNode);
}
function findRemovedFieldAndRemoveListener(fields) {
  var validateWithStateUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var field = arguments.length > 2 ? arguments[2] : undefined;
  var forceDelete = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!field) return;
  var ref = field.ref,
    mutationWatcher = field.mutationWatcher,
    options = field.options;
  if (!ref || !ref.type) return;
  var name = ref.name,
    type = ref.type;
  if (isRadioInput(type) && options) {
    options.forEach(function (_ref4, index) {
      var ref = _ref4.ref;
      if (options[index] && isDetached(ref) || forceDelete) {
        removeAllEventListeners(options[index], validateWithStateUpdate);
        (options[index].mutationWatcher || {
          disconnect: function disconnect() {}
        }).disconnect();
        options.splice(index, 1);
      }
    });
    if (!options.length) delete fields[name];
  } else if (isDetached(ref) || forceDelete) {
    removeAllEventListeners(ref, validateWithStateUpdate);
    if (mutationWatcher) mutationWatcher.disconnect();
    delete fields[name];
  }
}
var defaultReturn = {
  isValid: false,
  value: ''
};
var getRadioValue = function getRadioValue(options) {
  return options && isArray(options) ? options.reduce(function (previous, _ref5) {
    var _ref5$ref = _ref5.ref,
      checked = _ref5$ref.checked,
      value = _ref5$ref.value;
    return checked ? {
      isValid: true,
      value: value
    } : previous;
  }, defaultReturn) : defaultReturn;
};
var getMultipleSelectValue = function getMultipleSelectValue(options) {
  return _toConsumableArray(options).filter(function (_ref6) {
    var selected = _ref6.selected;
    return selected;
  }).map(function (_ref7) {
    var value = _ref7.value;
    return value;
  });
};
var isMultipleSelect = function isMultipleSelect(type) {
  return type === 'select-multiple';
};
function getFieldValue(fields, ref) {
  var type = ref.type,
    name = ref.name,
    options = ref.options,
    checked = ref.checked,
    value = ref.value;
  if (isRadioInput(type)) {
    var field = fields[name];
    return field ? getRadioValue(field.options).value : '';
  }
  if (isMultipleSelect(type)) return getMultipleSelectValue(options);
  if (isCheckBoxInput(type)) {
    if (checked) {
      return ref.attributes && ref.attributes.value ? isUndefined(value) || value === '' ? true : value : true;
    }
    return false;
  }
  return value;
}
var getFieldsValues = function getFieldsValues(fields) {
  return Object.values(fields).reduce(function (previous, _ref8) {
    var ref = _ref8.ref,
      name = _ref8.ref.name;
    return Object.assign(Object.assign({}, previous), _defineProperty({}, name, getFieldValue(fields, ref)));
  }, {});
};
var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
};
var isSameError = function isSameError(error, type, message) {
  return isObject(error) && error.type === type && error.message === message;
};
function shouldUpdateWithError(_ref9) {
  var errors = _ref9.errors,
    name = _ref9.name,
    error = _ref9.error,
    validFields = _ref9.validFields,
    fieldsWithValidation = _ref9.fieldsWithValidation;
  if (validFields.has(name) && isEmptyObject(error) || errors[name] && errors[name].isManual) {
    return false;
  }
  if (fieldsWithValidation.has(name) && !validFields.has(name) && isEmptyObject(error) || isEmptyObject(errors) && !isEmptyObject(error) || isEmptyObject(error) && errors[name] || !errors[name]) {
    return true;
  }
  return errors[name] && error[name] && !isSameError(errors[name], error[name].type, error[name].message);
}
var isRegex = function isRegex(value) {
  return value instanceof RegExp;
};
var getValueAndMessage = function getValueAndMessage(validationData) {
  return {
    value: isObject(validationData) && !isRegex(validationData) && !isNullOrUndefined(validationData.value) ? validationData.value : validationData,
    message: isObject(validationData) && !(validationData instanceof RegExp) && validationData.message ? validationData.message : ''
  };
};
var isString = function isString(value) {
  return typeof value === 'string';
};
var displayNativeError = function displayNativeError(nativeValidation, ref, message) {
  if (nativeValidation && isString(message)) ref.setCustomValidity(message);
};
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
var validateField = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref10, fields, nativeValidation) {
    var ref, _ref10$ref, type, value, name, checked, options, required, maxLength, minLength, min, max, pattern, validate, error, isRadio, isCheckBox, nativeError, exceedMax, exceedMin, _getValueAndMessage, maxValue, maxMessage, _getValueAndMessage2, minValue, minMessage, valueNumber, message, _getValueAndMessage3, maxLengthValue, maxLengthMessage, _getValueAndMessage4, minLengthValue, minLengthMessage, inputLength, _exceedMax, _exceedMin, _message, _getValueAndMessage5, patternValue, patternMessage, fieldValue, validateRef, result, isStringValue, _message2, validationResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ref = _ref10.ref, _ref10$ref = _ref10.ref, type = _ref10$ref.type, value = _ref10$ref.value, name = _ref10$ref.name, checked = _ref10$ref.checked, options = _ref10.options, required = _ref10.required, maxLength = _ref10.maxLength, minLength = _ref10.minLength, min = _ref10.min, max = _ref10.max, pattern = _ref10.pattern, validate = _ref10.validate;
            error = {};
            isRadio = isRadioInput(type);
            isCheckBox = isCheckBoxInput(type);
            nativeError = displayNativeError.bind(null, nativeValidation, ref);
            if (!(required && (isCheckBox && !checked || !isCheckBox && !isRadio && value === '' || isRadio && !getRadioValue(fields[name].options).isValid || !type && isNullOrUndefined(value)))) {
              _context2.next = 9;
              break;
            }
            error[name] = {
              type: 'required',
              message: isString(required) ? required : '',
              ref: isRadio ? fields[name].options[0].ref : ref
            };
            nativeError(required);
            return _context2.abrupt("return", error);
          case 9:
            if (!(!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
              _context2.next = 18;
              break;
            }
            _getValueAndMessage = getValueAndMessage(max), maxValue = _getValueAndMessage.value, maxMessage = _getValueAndMessage.message;
            _getValueAndMessage2 = getValueAndMessage(min), minValue = _getValueAndMessage2.value, minMessage = _getValueAndMessage2.message;
            if (type === 'number') {
              valueNumber = parseFloat(value);
              if (!isNullOrUndefined(maxValue)) exceedMax = valueNumber > maxValue;
              if (!isNullOrUndefined(minValue)) exceedMin = valueNumber < minValue;
            } else {
              if (isString(maxValue)) exceedMax = new Date(value) > new Date(maxValue);
              if (isString(minValue)) exceedMin = new Date(value) < new Date(minValue);
            }
            if (!(exceedMax || exceedMin)) {
              _context2.next = 18;
              break;
            }
            message = exceedMax ? maxMessage : minMessage;
            error[name] = {
              type: exceedMax ? 'max' : 'min',
              message: message,
              ref: ref
            };
            nativeError(message);
            return _context2.abrupt("return", error);
          case 18:
            if (!((maxLength || minLength) && isString(value))) {
              _context2.next = 29;
              break;
            }
            _getValueAndMessage3 = getValueAndMessage(maxLength), maxLengthValue = _getValueAndMessage3.value, maxLengthMessage = _getValueAndMessage3.message;
            _getValueAndMessage4 = getValueAndMessage(minLength), minLengthValue = _getValueAndMessage4.value, minLengthMessage = _getValueAndMessage4.message;
            inputLength = value.toString().length;
            _exceedMax = maxLength && inputLength > maxLengthValue;
            _exceedMin = minLength && inputLength < minLengthValue;
            if (!(_exceedMax || _exceedMin)) {
              _context2.next = 29;
              break;
            }
            _message = _exceedMax ? maxLengthMessage : minLengthMessage;
            error[name] = {
              type: _exceedMax ? 'maxLength' : 'minLength',
              message: _message,
              ref: ref
            };
            nativeError(_message);
            return _context2.abrupt("return", error);
          case 29:
            if (!pattern) {
              _context2.next = 35;
              break;
            }
            _getValueAndMessage5 = getValueAndMessage(pattern), patternValue = _getValueAndMessage5.value, patternMessage = _getValueAndMessage5.message;
            if (!(isRegex(patternValue) && !patternValue.test(value))) {
              _context2.next = 35;
              break;
            }
            error[name] = {
              type: 'pattern',
              message: patternMessage,
              ref: ref
            };
            nativeError(patternMessage);
            return _context2.abrupt("return", error);
          case 35:
            if (!validate) {
              _context2.next = 57;
              break;
            }
            fieldValue = getFieldValue(fields, ref);
            validateRef = isRadio && options ? options[0].ref : ref;
            if (!isFunction(validate)) {
              _context2.next = 50;
              break;
            }
            _context2.next = 41;
            return validate(fieldValue);
          case 41:
            result = _context2.sent;
            isStringValue = isString(result);
            if (!(isStringValue || isBoolean(result) && !result)) {
              _context2.next = 48;
              break;
            }
            _message2 = isStringValue ? result : '';
            error[name] = {
              type: 'validate',
              message: _message2,
              ref: validateRef
            };
            nativeError(_message2);
            return _context2.abrupt("return", error);
          case 48:
            _context2.next = 57;
            break;
          case 50:
            if (!isObject(validate)) {
              _context2.next = 57;
              break;
            }
            _context2.next = 53;
            return new Promise(function (resolve) {
              var values = Object.entries(validate);
              values.reduce( /*#__PURE__*/function () {
                var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(previous, _ref12, index) {
                  var _ref14, key, validate, lastChild, _result, _isStringValue, _message3, data;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _ref14 = _slicedToArray(_ref12, 2), key = _ref14[0], validate = _ref14[1];
                          lastChild = values.length - 1 === index;
                          if (!isFunction(validate)) {
                            _context.next = 12;
                            break;
                          }
                          _context.next = 5;
                          return validate(fieldValue);
                        case 5:
                          _result = _context.sent;
                          _isStringValue = isString(_result);
                          if (!(_isStringValue || isBoolean(_result) && !_result)) {
                            _context.next = 12;
                            break;
                          }
                          _message3 = _isStringValue ? _result : '';
                          data = {
                            type: key,
                            message: _message3,
                            ref: validateRef
                          };
                          nativeError(_message3);
                          return _context.abrupt("return", lastChild ? resolve(data) : data);
                        case 12:
                          return _context.abrupt("return", lastChild ? resolve(previous) : previous);
                        case 13:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return function (_x4, _x5, _x6) {
                  return _ref13.apply(this, arguments);
                };
              }(), {});
            });
          case 53:
            validationResult = _context2.sent;
            if (isEmptyObject(validationResult)) {
              _context2.next = 57;
              break;
            }
            error[name] = Object.assign({
              ref: validateRef
            }, validationResult);
            return _context2.abrupt("return", error);
          case 57:
            if (nativeValidation) ref.setCustomValidity('');
            return _context2.abrupt("return", error);
          case 59:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function validateField(_x, _x2, _x3) {
    return _ref11.apply(this, arguments);
  };
}();
function parseErrorSchema(error) {
  return error.inner.reduce(function (previous, _ref15) {
    var path = _ref15.path,
      message = _ref15.message,
      type = _ref15.type;
    return Object.assign(Object.assign({}, previous), _defineProperty({}, path, {
      message: message,
      ref: {},
      type: type
    }));
  }, {});
}
function validateWithSchema(_x7, _x8, _x9) {
  return _validateWithSchema.apply(this, arguments);
}
function _validateWithSchema() {
  _validateWithSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(validationSchema, validationSchemaOption, data) {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return validationSchema.validate(data, validationSchemaOption);
          case 3:
            _context10.t0 = _context10.sent;
            _context10.t1 = {};
            return _context10.abrupt("return", {
              result: _context10.t0,
              fieldErrors: _context10.t1
            });
          case 8:
            _context10.prev = 8;
            _context10.t2 = _context10["catch"](0);
            return _context10.abrupt("return", {
              fieldErrors: parseErrorSchema(_context10.t2),
              result: {}
            });
          case 11:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 8]]);
  }));
  return _validateWithSchema.apply(this, arguments);
}
function attachNativeValidation(ref, rules) {
  Object.entries(rules).forEach(function (_ref16) {
    var _ref17 = _slicedToArray(_ref16, 2),
      key = _ref17[0],
      value = _ref17[1];
    if (key === 'pattern' && isRegex(value)) {
      ref[key] = value.source;
    } else {
      ref[key] = key === 'required' ? true : value;
    }
  });
}
function get(object, keys, defaultVal) {
  keys = isArray(keys) ? keys : keys.replace(/\[/g, '.').replace(/\]/g, '').split('.');
  object = object[keys[0]];
  return object && keys.length > 1 ? get(object, keys.slice(1), defaultVal) : isUndefined(object) ? defaultVal : object;
}
var getDefaultValue = function getDefaultValue(defaultValues, name, defaultValue) {
  return isUndefined(defaultValues[name]) ? get(defaultValues, name, defaultValue) : defaultValues[name];
};
function flatArray(list) {
  return list.reduce(function (a, b) {
    return a.concat(isArray(b) ? flatArray(b) : b);
  }, []);
}
var getPath = function getPath(path, values) {
  return isArray(values) ? values.map(function (item, index) {
    var pathWithIndex = "".concat(path, "[").concat(index, "]");
    if (isArray(item)) {
      return getPath(pathWithIndex, item);
    } else if (isObject(item)) {
      return Object.entries(item).map(function (_ref18) {
        var _ref19 = _slicedToArray(_ref18, 2),
          key = _ref19[0],
          objectValue = _ref19[1];
        return isString(objectValue) ? "".concat(pathWithIndex, ".").concat(key) : getPath("".concat(pathWithIndex, ".").concat(key), objectValue);
      });
    }
    return pathWithIndex;
  }) : Object.entries(values).map(function (_ref20) {
    var _ref21 = _slicedToArray(_ref20, 2),
      key = _ref21[0],
      objectValue = _ref21[1];
    return isString(objectValue) ? "".concat(path, ".").concat(key) : getPath(path, objectValue);
  });
};
var getPath$1 = function getPath$1(parentPath, value) {
  return flatArray(getPath(parentPath, value));
};
var assignWatchFields = function assignWatchFields(fieldValues, fieldName, watchFields) {
  if (isUndefined(fieldValues) || isEmptyObject(fieldValues)) return undefined;
  if (!isUndefined(fieldValues[fieldName])) {
    watchFields[fieldName] = true;
    return fieldValues[fieldName];
  }
  var values = get(combineFieldValues(fieldValues), fieldName);
  if (values !== undefined) {
    var result = getPath$1(fieldName, values);
    if (isArray(result)) {
      result.forEach(function (name) {
        watchFields[name] = true;
      });
    }
  }
  return values;
};
var omitValidFields = function omitValidFields(errorFields, validFieldNames) {
  return Object.entries(errorFields).reduce(function (previous, _ref22) {
    var _ref23 = _slicedToArray(_ref22, 2),
      name = _ref23[0],
      error = _ref23[1];
    return validFieldNames.some(function (validFieldName) {
      return validFieldName === name;
    }) ? previous : Object.assign(Object.assign({}, previous), _defineProperty({}, name, error));
  }, {});
};
function onDomRemove(element, onDetachCallback) {
  var observer = new MutationObserver(function () {
    if (isDetached(element)) {
      observer.disconnect();
      onDetachCallback();
    }
  });
  observer.observe(window.document, {
    childList: true,
    subtree: true
  });
  return observer;
}
var modeChecker = function modeChecker(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange
  };
};
function useForm() {
  var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref24$mode = _ref24.mode,
    mode = _ref24$mode === void 0 ? VALIDATION_MODE.onSubmit : _ref24$mode,
    validationSchema = _ref24.validationSchema,
    _ref24$defaultValues = _ref24.defaultValues,
    defaultValues = _ref24$defaultValues === void 0 ? {} : _ref24$defaultValues,
    validationFields = _ref24.validationFields,
    nativeValidation = _ref24.nativeValidation,
    _ref24$submitFocusErr = _ref24.submitFocusError,
    submitFocusError = _ref24$submitFocusErr === void 0 ? true : _ref24$submitFocusErr,
    _ref24$validationSche = _ref24.validationSchemaOption,
    validationSchemaOption = _ref24$validationSche === void 0 ? {
      abortEarly: false
    } : _ref24$validationSche;
  var fieldsRef = useRef({});
  var errorsRef = useRef({});
  var schemaErrorsRef = useRef({});
  var touchedFieldsRef = useRef(new Set());
  var watchFieldsRef = useRef({});
  var dirtyFieldsRef = useRef(new Set());
  var fieldsWithValidationRef = useRef(new Set());
  var validFieldsRef = useRef(new Set());
  var defaultValuesRef = useRef({});
  var isUnMount = useRef(false);
  var isWatchAllRef = useRef(false);
  var isSubmittedRef = useRef(false);
  var isDirtyRef = useRef(false);
  var isSchemaValidateTriggeredRef = useRef(false);
  var validationFieldsRef = useRef(validationFields);
  var validateAndUpdateStateRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    submitCount = _useState4[0],
    setSubmitCount = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    reRenderForm = _useState6[1];
  var _useRef$current = useRef(modeChecker(mode)).current,
    isOnBlur = _useRef$current.isOnBlur,
    isOnSubmit = _useRef$current.isOnSubmit;
  validationFieldsRef.current = validationFields;
  var combineErrorsRef = function combineErrorsRef(data) {
    return Object.assign(Object.assign({}, errorsRef.current), data);
  };
  var renderBaseOnError = useCallback(function (name, error) {
    var shouldRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (isEmptyObject(error)) {
      delete errorsRef.current[name];
      if (fieldsWithValidationRef.current.has(name) || validationSchema) validFieldsRef.current.add(name);
    } else {
      validFieldsRef.current.delete(name);
    }
    if (shouldRender) reRenderForm({});
  }, [validationSchema]);
  var setFieldValue = function setFieldValue(name, value) {
    var field = fieldsRef.current[name];
    if (!field) return false;
    var ref = field.ref;
    var type = ref.type;
    var options = field.options;
    if (isRadioInput(type) && options) {
      options.forEach(function (_ref25) {
        var radioRef = _ref25.ref;
        return radioRef.checked = radioRef.value === value;
      });
    } else if (isMultipleSelect(type)) {
      _toConsumableArray(ref.options).forEach(function (selectRef) {
        return selectRef.selected = value.includes(selectRef.value);
      });
    } else {
      ref[isCheckBoxInput(type) ? 'checked' : 'value'] = value;
    }
    return type;
  };
  var setDirty = function setDirty(name) {
    if (!fieldsRef.current[name]) return false;
    var isDirty = defaultValuesRef.current[name] !== getFieldValue(fieldsRef.current, fieldsRef.current[name].ref);
    var isDirtyChanged = dirtyFieldsRef.current.has(name) !== isDirty;
    if (isDirty) {
      dirtyFieldsRef.current.add(name);
    } else {
      dirtyFieldsRef.current.delete(name);
    }
    isDirtyRef.current = !!dirtyFieldsRef.current.size;
    return isDirtyChanged;
  };
  var setValueInternal = useCallback(function (name, value) {
    var shouldRender = setFieldValue(name, value);
    if (setDirty(name) || shouldRender || !touchedFieldsRef.current.has(name)) {
      touchedFieldsRef.current.add(name);
      reRenderForm({});
    }
  }, []);
  var executeValidation = useCallback( /*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref26) {
      var name,
        value,
        shouldRender,
        field,
        error,
        _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              name = _ref26.name, value = _ref26.value;
              shouldRender = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
              field = fieldsRef.current[name];
              if (field) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return", false);
            case 5:
              if (!isUndefined(value)) setValueInternal(name, value);
              _context3.next = 8;
              return validateField(field, fieldsRef.current);
            case 8:
              error = _context3.sent;
              errorsRef.current = combineErrorsRef(error);
              renderBaseOnError(name, error, shouldRender);
              return _context3.abrupt("return", isEmptyObject(error));
            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x10) {
      return _ref27.apply(this, arguments);
    };
  }(), [renderBaseOnError, setValueInternal]);
  var validateWithSchemaCurry = useCallback(validateWithSchema.bind(null, validationSchema, validationSchemaOption), []);
  var executeSchemaValidation = useCallback( /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
      var _yield$validateWithSc, fieldErrors, names, validFieldNames;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return validateWithSchemaCurry(combineFieldValues(getFieldsValues(fieldsRef.current)));
            case 2:
              _yield$validateWithSc = _context4.sent;
              fieldErrors = _yield$validateWithSc.fieldErrors;
              names = isArray(payload) ? payload.map(function (_ref29) {
                var name = _ref29.name;
                return name;
              }) : [payload.name];
              validFieldNames = names.filter(function (name) {
                return !fieldErrors[name];
              });
              schemaErrorsRef.current = fieldErrors;
              isSchemaValidateTriggeredRef.current = true;
              errorsRef.current = omitValidFields(combineErrorsRef(Object.entries(fieldErrors).filter(function (_ref30) {
                var _ref31 = _slicedToArray(_ref30, 1),
                  key = _ref31[0];
                return names.includes(key);
              }).reduce(function (previous, _ref32) {
                var _ref33 = _slicedToArray(_ref32, 2),
                  name = _ref33[0],
                  error = _ref33[1];
                return Object.assign(Object.assign({}, previous), _defineProperty({}, name, error));
              }, {})), validFieldNames);
              reRenderForm({});
              return _context4.abrupt("return", isEmptyObject(errorsRef.current));
            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function (_x11) {
      return _ref28.apply(this, arguments);
    };
  }(), [validateWithSchemaCurry]);
  var triggerValidation = useCallback( /*#__PURE__*/function () {
    var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
      var fields, result;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              fields = payload || Object.keys(fieldsRef.current).map(function (name) {
                return {
                  name: name
                };
              });
              if (!validationSchema) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return", executeSchemaValidation(fields));
            case 3:
              if (!isArray(fields)) {
                _context6.next = 9;
                break;
              }
              _context6.next = 6;
              return Promise.all(fields.map( /*#__PURE__*/function () {
                var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return executeValidation(data, false);
                        case 2:
                          return _context5.abrupt("return", _context5.sent);
                        case 3:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));
                return function (_x13) {
                  return _ref35.apply(this, arguments);
                };
              }()));
            case 6:
              result = _context6.sent;
              reRenderForm({});
              return _context6.abrupt("return", result.every(Boolean));
            case 9:
              _context6.next = 11;
              return executeValidation(fields);
            case 11:
              return _context6.abrupt("return", _context6.sent);
            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function (_x12) {
      return _ref34.apply(this, arguments);
    };
  }(), [executeSchemaValidation, executeValidation, validationSchema]);
  var setValue = useCallback(function (name, value) {
    var shouldValidate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    setValueInternal(name, value);
    if (shouldValidate) return triggerValidation({
      name: name
    });
  }, [setValueInternal, triggerValidation]);
  validateAndUpdateStateRef.current = validateAndUpdateStateRef.current ? validateAndUpdateStateRef.current : /*#__PURE__*/function () {
    var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref36) {
      var name, type, fields, errors, ref, error, isBlurEvent, isValidateDisabled, shouldUpdateState, _yield$validateWithSc2, fieldErrors, shouldUpdate;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              name = _ref36.target.name, type = _ref36.type;
              if (!(isArray(validationFieldsRef.current) && !validationFieldsRef.current.includes(name))) {
                _context7.next = 3;
                break;
              }
              return _context7.abrupt("return");
            case 3:
              fields = fieldsRef.current;
              errors = errorsRef.current;
              ref = fields[name];
              if (ref) {
                _context7.next = 8;
                break;
              }
              return _context7.abrupt("return");
            case 8:
              isBlurEvent = type === 'blur';
              isValidateDisabled = isOnSubmit && !isSubmittedRef.current || isOnBlur && !isBlurEvent && !errors[name];
              shouldUpdateState = isWatchAllRef.current || watchFieldsRef.current[name] || setDirty(name);
              if (!touchedFieldsRef.current.has(name)) {
                touchedFieldsRef.current.add(name);
                shouldUpdateState = true;
              }
              if (!isValidateDisabled) {
                _context7.next = 14;
                break;
              }
              return _context7.abrupt("return", shouldUpdateState ? reRenderForm({}) : undefined);
            case 14:
              if (!validationSchema) {
                _context7.next = 24;
                break;
              }
              _context7.next = 17;
              return validateWithSchemaCurry(combineFieldValues(getFieldsValues(fields)));
            case 17:
              _yield$validateWithSc2 = _context7.sent;
              fieldErrors = _yield$validateWithSc2.fieldErrors;
              schemaErrorsRef.current = fieldErrors;
              isSchemaValidateTriggeredRef.current = true;
              error = fieldErrors[name] ? _defineProperty({}, name, fieldErrors[name]) : {};
              _context7.next = 27;
              break;
            case 24:
              _context7.next = 26;
              return validateField(ref, fields, nativeValidation);
            case 26:
              error = _context7.sent;
            case 27:
              shouldUpdate = shouldUpdateWithError({
                errors: errors,
                error: error,
                name: name,
                validFields: validFieldsRef.current,
                fieldsWithValidation: fieldsWithValidationRef.current
              });
              if (!shouldUpdate) {
                _context7.next = 32;
                break;
              }
              errorsRef.current = combineErrorsRef(error);
              renderBaseOnError(name, error);
              return _context7.abrupt("return");
            case 32:
              if (shouldUpdateState) reRenderForm({});
            case 33:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return function (_x14) {
      return _ref37.apply(this, arguments);
    };
  }();
  var resetFieldRef = function resetFieldRef(name) {
    delete watchFieldsRef.current[name];
    delete errorsRef.current[name];
    delete fieldsRef.current[name];
    delete defaultValuesRef.current[name];
    [touchedFieldsRef, dirtyFieldsRef, fieldsWithValidationRef, validFieldsRef].forEach(function (data) {
      return data.current.delete(name);
    });
  };
  var removeEventListenerAndRef = useCallback(function (field, forceDelete) {
    if (!field) return;
    findRemovedFieldAndRemoveListener(fieldsRef.current, validateAndUpdateStateRef.current, field, forceDelete);
    resetFieldRef(field.ref.name);
  }, []);
  function clearError(name) {
    if (isString(name)) {
      delete errorsRef.current[name];
    } else if (isArray(name)) {
      name.forEach(function (fieldName) {
        return delete errorsRef.current[fieldName];
      });
    } else {
      errorsRef.current = {};
    }
    reRenderForm({});
  }
  var setError = function setError(name, type, message, ref) {
    var errors = errorsRef.current;
    if (!isSameError(errors[name], type, message)) {
      errors[name] = {
        type: type,
        message: message,
        ref: ref,
        isManual: true
      };
      reRenderForm({});
    }
  };
  function watch(fieldNames, defaultValue) {
    var fieldValues = getFieldsValues(fieldsRef.current);
    var watchFields = watchFieldsRef.current;
    if (isString(fieldNames)) {
      var value = assignWatchFields(fieldValues, fieldNames, watchFields);
      return !isUndefined(value) ? value : isUndefined(defaultValue) ? getDefaultValue(defaultValues, fieldNames) : defaultValue;
    }
    if (isArray(fieldNames)) {
      return fieldNames.reduce(function (previous, name) {
        var value = getDefaultValue(defaultValues, name);
        if (isEmptyObject(fieldsRef.current) && !isUndefined(defaultValue) && !isString(defaultValue)) {
          value = defaultValue[name];
        } else {
          var tempValue = assignWatchFields(fieldValues, name, watchFields);
          if (!isUndefined(tempValue)) value = tempValue;
        }
        return Object.assign(Object.assign({}, previous), _defineProperty({}, name, value));
      }, {});
    }
    isWatchAllRef.current = true;
    return !isEmptyObject(fieldValues) && fieldValues || defaultValue || defaultValues;
  }
  function registerIntoFieldsRef(ref) {
    var validateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!ref.name) return console.warn('Miss ref', ref);
    var name = ref.name,
      type = ref.type,
      value = ref.value;
    var fieldAttributes = Object.assign({
      ref: ref
    }, validateOptions);
    var fields = fieldsRef.current;
    var isRadio = isRadioInput(type);
    var currentField = fields[name];
    var isRegistered = isRadio ? currentField && isArray(currentField.options) && currentField.options.find(function (_ref39) {
      var ref = _ref39.ref;
      return value === ref.value;
    }) : currentField;
    if (isRegistered) return;
    if (!type) {
      fields[name] = fieldAttributes;
    } else {
      var mutationWatcher = onDomRemove(ref, function () {
        return removeEventListenerAndRef(fieldAttributes);
      });
      if (isRadio) {
        if (!currentField) fields[name] = {
          options: [],
          ref: {
            type: RADIO_INPUT,
            name: name
          }
        };
        fields[name] = Object.assign(Object.assign({}, fields[name]), validateOptions);
        fields[name].options.push({
          ref: ref,
          mutationWatcher: mutationWatcher
        });
      } else {
        fields[name] = Object.assign(Object.assign({}, fieldAttributes), {
          mutationWatcher: mutationWatcher
        });
      }
    }
    if (!isEmptyObject(defaultValues)) {
      var defaultValue = getDefaultValue(defaultValues, name);
      if (!isUndefined(defaultValue)) setFieldValue(name, defaultValue);
    }
    if (validateOptions && !isEmptyObject(validateOptions)) {
      fieldsWithValidationRef.current.add(name);
      if (!isOnSubmit) {
        if (validationSchema) {
          isSchemaValidateTriggeredRef.current = true;
          validateWithSchemaCurry(combineFieldValues(getFieldsValues(fields))).then(function (_ref40) {
            var fieldErrors = _ref40.fieldErrors;
            schemaErrorsRef.current = fieldErrors;
            if (isEmptyObject(schemaErrorsRef.current)) reRenderForm({});
          });
        } else {
          validateField(fields[name], fields).then(function (error) {
            if (isEmptyObject(error)) validFieldsRef.current.add(name);
            if (validFieldsRef.current.size === fieldsWithValidationRef.current.size) reRenderForm({});
          });
        }
      }
    }
    if (!defaultValuesRef.current[name]) defaultValuesRef.current[name] = getFieldValue(fields, fields[name].ref);
    if (!type) return;
    var field = isRadio ? fields[name].options[fields[name].options.length - 1] : fields[name];
    if (nativeValidation && validateOptions) {
      attachNativeValidation(ref, validateOptions);
    } else {
      attachEventListeners({
        field: field,
        isRadio: isRadio,
        validateAndStateUpdate: validateAndUpdateStateRef.current,
        isOnBlur: isOnBlur
      });
    }
  }
  function register(refOrValidateRule, validationOptions) {
    if (typeof window === 'undefined' || !refOrValidateRule) return;
    if (isObject(refOrValidateRule) && (validationOptions || 'name' in refOrValidateRule)) {
      registerIntoFieldsRef(refOrValidateRule, validationOptions);
      return;
    }
    return function (ref) {
      return ref && registerIntoFieldsRef(ref, refOrValidateRule);
    };
  }
  function unregister(names) {
    if (isEmptyObject(fieldsRef.current)) return;
    (isArray(names) ? names : [names]).forEach(function (fieldName) {
      return removeEventListenerAndRef(fieldsRef.current[fieldName], true);
    });
  }
  var handleSubmit = function handleSubmit(callback) {
    return /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
        var fieldErrors, fieldValues, firstFocusError, fields, fieldsToValidate, output, _yield$fieldsToValida, errors, values;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (e) {
                  e.preventDefault();
                  e.persist();
                }
                firstFocusError = true;
                fields = fieldsRef.current;
                fieldsToValidate = validationFields ? validationFields.map(function (name) {
                  return fieldsRef.current[name];
                }) : Object.values(fields);
                setIsSubmitting(true);
                if (!validationSchema) {
                  _context9.next = 15;
                  break;
                }
                fieldValues = getFieldsValues(fields);
                _context9.next = 9;
                return validateWithSchema(validationSchema, validationSchemaOption, combineFieldValues(fieldValues));
              case 9:
                output = _context9.sent;
                schemaErrorsRef.current = output.fieldErrors;
                fieldErrors = output.fieldErrors;
                fieldValues = output.result;
                _context9.next = 22;
                break;
              case 15:
                _context9.next = 17;
                return fieldsToValidate.reduce( /*#__PURE__*/function () {
                  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(previous, field) {
                    var resolvedPrevious, ref, _field$ref, name, focus, fieldError;
                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            if (field) {
                              _context8.next = 2;
                              break;
                            }
                            return _context8.abrupt("return", previous);
                          case 2:
                            _context8.next = 4;
                            return previous;
                          case 4:
                            resolvedPrevious = _context8.sent;
                            ref = field.ref, _field$ref = field.ref, name = _field$ref.name, focus = _field$ref.focus;
                            if (fields[name]) {
                              _context8.next = 8;
                              break;
                            }
                            return _context8.abrupt("return", Promise.resolve(resolvedPrevious));
                          case 8:
                            _context8.next = 10;
                            return validateField(field, fields, nativeValidation);
                          case 10:
                            fieldError = _context8.sent;
                            if (!fieldError[name]) {
                              _context8.next = 16;
                              break;
                            }
                            if (submitFocusError && firstFocusError && focus) {
                              ref.focus();
                              firstFocusError = false;
                            }
                            resolvedPrevious.errors = Object.assign(Object.assign({}, resolvedPrevious.errors), fieldError);
                            validFieldsRef.current.delete(name);
                            return _context8.abrupt("return", Promise.resolve(resolvedPrevious));
                          case 16:
                            if (fieldsWithValidationRef.current.has(name)) validFieldsRef.current.add(name);
                            resolvedPrevious.values[name] = getFieldValue(fields, ref);
                            return _context8.abrupt("return", Promise.resolve(resolvedPrevious));
                          case 19:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));
                  return function (_x16, _x17) {
                    return _ref42.apply(this, arguments);
                  };
                }(), Promise.resolve({
                  errors: {},
                  values: {}
                }));
              case 17:
                _yield$fieldsToValida = _context9.sent;
                errors = _yield$fieldsToValida.errors;
                values = _yield$fieldsToValida.values;
                fieldErrors = errors;
                fieldValues = values;
              case 22:
                if (!isEmptyObject(fieldErrors)) {
                  _context9.next = 28;
                  break;
                }
                errorsRef.current = {};
                _context9.next = 26;
                return callback(combineFieldValues(fieldValues), e);
              case 26:
                _context9.next = 29;
                break;
              case 28:
                errorsRef.current = fieldErrors;
              case 29:
                if (!isUnMount.current) {
                  _context9.next = 31;
                  break;
                }
                return _context9.abrupt("return");
              case 31:
                isSubmittedRef.current = true;
                setIsSubmitting(false);
                setSubmitCount(submitCount + 1);
              case 34:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
      return function (_x15) {
        return _ref41.apply(this, arguments);
      };
    }();
  };
  var resetRefs = function resetRefs() {
    errorsRef.current = {};
    schemaErrorsRef.current = {};
    touchedFieldsRef.current = new Set();
    watchFieldsRef.current = {};
    dirtyFieldsRef.current = new Set();
    fieldsWithValidationRef.current = new Set();
    validFieldsRef.current = new Set();
    defaultValuesRef.current = {};
    isWatchAllRef.current = false;
    isSubmittedRef.current = false;
    isDirtyRef.current = false;
    isSchemaValidateTriggeredRef.current = false;
  };
  var reset = useCallback(function (values) {
    var fieldsKeyValue = Object.entries(fieldsRef.current);
    for (var _i = 0, _fieldsKeyValue = fieldsKeyValue; _i < _fieldsKeyValue.length; _i++) {
      var _ref47 = _fieldsKeyValue[_i];
      var _ref44 = _slicedToArray(_ref47, 2);
      var value = _ref44[1];
      if (value && value.ref && value.ref.closest) {
        try {
          value.ref.closest('form').reset();
          break;
        } catch (_a) {}
      }
    }
    resetRefs();
    if (values) {
      fieldsKeyValue.forEach(function (_ref45) {
        var _ref46 = _slicedToArray(_ref45, 1),
          key = _ref46[0];
        return setFieldValue(key, getDefaultValue(values, key, ''));
      });
      defaultValuesRef.current = values;
    }
    setSubmitCount(0);
  }, []);
  var getValues = function getValues(payload) {
    var fieldValues = getFieldsValues(fieldsRef.current);
    var output = payload && payload.nest ? combineFieldValues(fieldValues) : fieldValues;
    return isEmptyObject(output) ? defaultValues : output;
  };
  useEffect(function () {
    return function () {
      isUnMount.current = true;
      fieldsRef.current && Object.values(fieldsRef.current).forEach(function (field) {
        return removeEventListenerAndRef(field, true);
      });
    };
  }, [removeEventListenerAndRef]);
  return {
    register: useCallback(register, [registerIntoFieldsRef]),
    unregister: useCallback(unregister, [unregister, removeEventListenerAndRef]),
    handleSubmit: handleSubmit,
    watch: watch,
    reset: reset,
    clearError: clearError,
    setError: setError,
    setValue: setValue,
    triggerValidation: triggerValidation,
    getValues: getValues,
    errors: validationFields ? Object.keys(errorsRef.current).reduce(function (previous, key) {
      return Object.assign(Object.assign({}, previous), validationFields.includes(key) ? _defineProperty({}, key, errorsRef.current[key]) : null);
    }, {}) : errorsRef.current,
    formState: Object.assign({
      dirty: isDirtyRef.current,
      isSubmitted: isSubmittedRef.current,
      submitCount: submitCount,
      touched: _toConsumableArray(touchedFieldsRef.current),
      isSubmitting: isSubmitting
    }, isOnSubmit ? {
      isValid: isEmptyObject(errorsRef.current)
    } : {
      isValid: validationSchema ? isSchemaValidateTriggeredRef.current && isEmptyObject(schemaErrorsRef.current) : fieldsWithValidationRef.current.size ? !isEmptyObject(fieldsRef.current) && validFieldsRef.current.size >= fieldsWithValidationRef.current.size : !isEmptyObject(fieldsRef.current)
    })
  };
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var FormGlobalContext = createContext(null);
function useFormContext() {
  return useContext(FormGlobalContext);
}
function FormContext(props) {
  var children = props.children,
    rest = __rest(props, ["children"]);
  return createElement(FormGlobalContext.Provider, {
    value: rest
  }, children);
}
export default useForm;
export { FormContext, useFormContext };